import { AccordionSubjectAttributes as SubjectAttributesVM } from 'shell/view-models/accordion-subject-attributes';
import { SubjectAttributes } from 'shell/models/person/subject-attributes';

export const transformSubjectAttributes = (
  values: SubjectAttributesVM | undefined
): SubjectAttributes | undefined => {
  const returnData: SubjectAttributes | undefined = values
    ? {
        senzaFissaDimora: values?.homeless ? 'S' : 'N',
        soggettoCertificabile: values?.subject || undefined,
      }
    : undefined;

  return returnData;
};
